import { render, staticRenderFns } from "./cartSummary.vue?vue&type=template&id=350a0ce4&scoped=true&"
import script from "./cartSummary.vue?vue&type=script&lang=js&"
export * from "./cartSummary.vue?vue&type=script&lang=js&"
import style0 from "./cartSummary.vue?vue&type=style&index=0&id=350a0ce4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350a0ce4",
  null
  
)

export default component.exports